import axios from "axios";

export default {
  async create(formData) {
    const files = new FormData();
    files.append("files", formData.pdfAttachment);

    const data = formData;
    data.pdfAttachment = undefined;
    files.append("data", JSON.stringify(data));

    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    return axios.post(`/finance-invoices`, files, config);
  },
  async findAll() {
    return axios.get(`/finance-invoices`);
  },
  async getAttachementPdf(formData) {
    return axios.get(`/finance-invoices/${formData.id}/pdf-attachment`, { responseType: 'arraybuffer' });
  },
  async getMergedPdf(formData) {
    return axios.get(`/finance-invoices/${formData.id}/pdf-merged`, { responseType: 'arraybuffer' });
  },
  async PDFPreview(formData) {
    return axios.post(`/finance-invoices/pdf-preview`, formData, { responseType: 'arraybuffer' });
  },
  async delete({ id }) {
    return axios.delete(`/finance-invoices/${id}`);
  },
};